import {createBrowserHistory} from 'history'

export const BASENAME = '/'
export default createBrowserHistory({basename: BASENAME})
